// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Right Sidebar (Reference Style Mapping) ===== */

/* Container: relative min-h-0 overflow-y-auto overflow-x-visible rounded-l-[28px] rounded-r-none border border-r-0 border-slate-200/80 bg-white shadow-[0_18px_45px_rgba(15,23,42,0.08)] no-scrollbar */
.kds-right-sidebar {
  position: relative;
  min-height: 0;
  overflow-y: auto;
  overflow-x: visible;
  border-top-left-radius: 28px;
  border-bottom-left-radius: 28px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid rgba(226, 232, 240, 0.8); /* border-slate-200/80 */
  border-right: 0;
  background-color: #ffffff;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  width: 90px;
  display: flex;
  flex-direction: column;
}

/* Thin scrollbar; overflow-y: auto only shows it when the buttons overflow */
.kds-right-sidebar {
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #cbd5e1 transparent;
}
.kds-right-sidebar::-webkit-scrollbar {
  width: 4px;
}
.kds-right-sidebar::-webkit-scrollbar-track {
  background: transparent;
}
.kds-right-sidebar::-webkit-scrollbar-thumb {
  background-color: #cbd5e1; /* slate-300 */
  border-radius: 9999px;
}
.kds-right-sidebar::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8; /* slate-400 */
}

/* Button wrapper: relative */
.sidebar-btn-wrapper {
  position: relative;
  width: 100%;
}

/* Button: group relative flex h-[88px] w-full flex-col items-center justify-center gap-2 border-b border-slate-100 px-2 py-3 text-center transition-colors last:border-b-0 bg-white hover:bg-slate-50 */
.sidebar-btn {
  position: relative;
  display: flex;
  height: 6.286em; /* 88px at 14px base - relative for font scaling */
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.571em; /* 8px at 14px base */
  border: none;
  border-bottom: 1px solid #f1f5f9; /* border-slate-100 */
  padding: 0.857em 0.571em; /* 12px 8px at 14px base */
  text-align: center;
  background-color: #ffffff;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.sidebar-btn-wrapper:last-child .sidebar-btn {
  border-bottom: none; /* last:border-b-0 */
}

.sidebar-btn:hover {
  background-color: #f8fafc; /* hover:bg-slate-50 */
}

/* Icon wrapper inside button: flex h-10 w-10 items-center justify-center rounded-full ring-1 ring-black/[0.04] transition-all */
.sidebar-icon-container {
  display: flex;
  height: 2.857em; /* 40px at 14px base - relative for font scaling */
  width: 2.857em;  /* 40px at 14px base */
  align-items: center;
  justify-content: center;
  border-radius: 9999px; /* rounded-full */
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04); /* ring-1 ring-black/[0.04] */
  transition: all 0.2s ease;
}

/* Color schemes for the icon containers:
   1) Pause: bg-blue-50 text-blue-500
   2) Menu Stock: let's use bg-violet-50 text-violet-500
   3) Inventory Stock: bg-slate-50 text-slate-500
   4) Completed: bg-emerald-50 text-emerald-500
   5) Font Change: bg-indigo-50 text-indigo-500
   6) Recalled list: bg-rose-50 text-rose-500
   7) Redo Accept: bg-amber-50 text-amber-500
   8) Settings: bg-slate-100 text-slate-700
*/
.icon-pause-online-order {
  background-color: #eff6ff; /* bg-blue-50 */
  color: #3b82f6; /* text-blue-500 */
}

.icon-menu-stock {
  background-color: #f5f3ff; /* bg-violet-50 */
  color: #8b5cf6; /* text-violet-500 */
}

.icon-inventory-stock {
  background-color: #f8fafc; /* bg-slate-50 */
  color: #64748b; /* text-slate-500 */
}

.icon-completed {
  background-color: #ecfdf5; /* bg-emerald-50 */
  color: #10b981; /* text-emerald-500 */
}

.icon-font-change {
  background-color: #e0e7ff; /* bg-indigo-50 */
  color: #6366f1; /* text-indigo-500 */
}

.icon-recalled-list {
  background-color: #fff1f2; /* bg-rose-50 */
  color: #f43f5e; /* text-rose-500 */
}

.icon-redo-accept {
  background-color: #fffbeb; /* bg-amber-50 */
  color: #f59e0b; /* text-amber-500 */
}

.icon-settings {
  background-color: #f1f5f9; /* bg-slate-100 */
  color: #334155; /* text-slate-700 */
}

/* SVG icon size: h-4.5 w-4.5 -> 18px */
.sidebar-icon-svg {
  width: 1.286em; /* 18px at 14px base - relative for font scaling */
  height: 1.286em; /* 18px at 14px base */
}

/* Text wrapper: text-center leading-tight */
.sidebar-label-wrapper {
  text-align: center;
  line-height: 1.25; /* leading-tight */
}

/* Label: block text-[9px] font-medium leading-tight text-slate-600 */
.sidebar-label {
  display: block;
  font-size: 0.643em; /* 9px at 14px base - relative for font scaling */
  font-weight: 500;
  line-height: 1.25;
  color: #475569; /* text-slate-600 */
}

/* ==============================
   Font Change Dropdown (No Layout Impact)
   ============================== */
.font-options-dropdown {
  position: fixed; /* independent of sidebar layout */
  top: 50%;
  right: 105px; /* adjusted to sit perfectly next to the 90px sidebar */
  transform: translateY(-50%);
  background: #ffffff;
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 12px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  padding: 6px;
  width: 120px;
}

.font-options-dropdown button {
  background: none;
  border: none;
  text-align: left;
  padding: 8px 12px;
  font-size: 0.929em; /* 13px at 14px base - relative for font scaling */
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.2s ease, color 0.2s ease;
  color: #475569;
}

.font-options-dropdown button:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.font-options-dropdown button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.font-options-dropdown button.is-selected {
  background-color: #eef2ff; /* indigo-50, matches the Font Change icon */
  color: #4f46e5; /* indigo-600 */
  font-weight: 600;
}

.font-options-dropdown button svg {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
}

/* Optional small arrow (does not affect layout) */
.font-options-dropdown::before {
  content: "";
  position: absolute;
  top: 50%;
  right: -6px;
  transform: translateY(-50%) rotate(45deg);
  width: 10px;
  height: 10px;
  background: #fff;
  border-right: 1px solid rgba(226, 232, 240, 0.8);
  border-top: 1px solid rgba(226, 232, 240, 0.8);
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/SideBar/sideBar.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD,wMAAwM;AACxM;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;EAC1B,6BAA6B;EAC7B,0CAA0C,EAAE,wBAAwB;EACpE,eAAe;EACf,yBAAyB;EACzB,8CAA8C;EAC9C,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA,6EAA6E;AAC7E;EACE,qBAAqB,EAAE,YAAY;EACnC,oCAAoC;AACtC;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB,EAAE,cAAc;EACzC,qBAAqB;AACvB;AACA;EACE,yBAAyB,EAAE,cAAc;AAC3C;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,wMAAwM;AACxM;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe,EAAE,kDAAkD;EACnE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAE,qBAAqB;EACnC,YAAY;EACZ,gCAAgC,EAAE,qBAAqB;EACvD,wBAAwB,EAAE,0BAA0B;EACpD,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB,EAAE,oBAAoB;AAC3C;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA,gIAAgI;AAChI;EACE,aAAa;EACb,eAAe,EAAE,kDAAkD;EACnE,cAAc,GAAG,sBAAsB;EACvC,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB,EAAE,iBAAiB;EACxC,yCAAyC,EAAE,6BAA6B;EACxE,yBAAyB;AAC3B;;AAEA;;;;;;;;;CASC;AACD;EACE,yBAAyB,EAAE,eAAe;EAC1C,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc,EAAE,mBAAmB;AACrC;;AAEA,uCAAuC;AACvC;EACE,cAAc,EAAE,kDAAkD;EAClE,eAAe,EAAE,sBAAsB;AACzC;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,iBAAiB,EAAE,kBAAkB;AACvC;;AAEA,qEAAqE;AACrE;EACE,cAAc;EACd,kBAAkB,EAAE,iDAAiD;EACrE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc,EAAE,mBAAmB;AACrC;;AAEA;;mCAEmC;AACnC;EACE,eAAe,EAAE,kCAAkC;EACnD,QAAQ;EACR,YAAY,EAAE,uDAAuD;EACrE,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,mFAAmF;EACnF,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB,EAAE,kDAAkD;EACtE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uDAAuD;EACvD,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,yBAAyB,EAAE,4CAA4C;EACvE,cAAc,EAAE,eAAe;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;EAChD,8CAA8C;AAChD","sourcesContent":["/* ===== Right Sidebar (Reference Style Mapping) ===== */\n\n/* Container: relative min-h-0 overflow-y-auto overflow-x-visible rounded-l-[28px] rounded-r-none border border-r-0 border-slate-200/80 bg-white shadow-[0_18px_45px_rgba(15,23,42,0.08)] no-scrollbar */\n.kds-right-sidebar {\n  position: relative;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: visible;\n  border-top-left-radius: 28px;\n  border-bottom-left-radius: 28px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border: 1px solid rgba(226, 232, 240, 0.8); /* border-slate-200/80 */\n  border-right: 0;\n  background-color: #ffffff;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);\n  width: 90px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Thin scrollbar; overflow-y: auto only shows it when the buttons overflow */\n.kds-right-sidebar {\n  scrollbar-width: thin; /* Firefox */\n  scrollbar-color: #cbd5e1 transparent;\n}\n.kds-right-sidebar::-webkit-scrollbar {\n  width: 4px;\n}\n.kds-right-sidebar::-webkit-scrollbar-track {\n  background: transparent;\n}\n.kds-right-sidebar::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1; /* slate-300 */\n  border-radius: 9999px;\n}\n.kds-right-sidebar::-webkit-scrollbar-thumb:hover {\n  background-color: #94a3b8; /* slate-400 */\n}\n\n/* Button wrapper: relative */\n.sidebar-btn-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n/* Button: group relative flex h-[88px] w-full flex-col items-center justify-center gap-2 border-b border-slate-100 px-2 py-3 text-center transition-colors last:border-b-0 bg-white hover:bg-slate-50 */\n.sidebar-btn {\n  position: relative;\n  display: flex;\n  height: 6.286em; /* 88px at 14px base - relative for font scaling */\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.571em; /* 8px at 14px base */\n  border: none;\n  border-bottom: 1px solid #f1f5f9; /* border-slate-100 */\n  padding: 0.857em 0.571em; /* 12px 8px at 14px base */\n  text-align: center;\n  background-color: #ffffff;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.sidebar-btn-wrapper:last-child .sidebar-btn {\n  border-bottom: none; /* last:border-b-0 */\n}\n\n.sidebar-btn:hover {\n  background-color: #f8fafc; /* hover:bg-slate-50 */\n}\n\n/* Icon wrapper inside button: flex h-10 w-10 items-center justify-center rounded-full ring-1 ring-black/[0.04] transition-all */\n.sidebar-icon-container {\n  display: flex;\n  height: 2.857em; /* 40px at 14px base - relative for font scaling */\n  width: 2.857em;  /* 40px at 14px base */\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px; /* rounded-full */\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04); /* ring-1 ring-black/[0.04] */\n  transition: all 0.2s ease;\n}\n\n/* Color schemes for the icon containers:\n   1) Pause: bg-blue-50 text-blue-500\n   2) Menu Stock: let's use bg-violet-50 text-violet-500\n   3) Inventory Stock: bg-slate-50 text-slate-500\n   4) Completed: bg-emerald-50 text-emerald-500\n   5) Font Change: bg-indigo-50 text-indigo-500\n   6) Recalled list: bg-rose-50 text-rose-500\n   7) Redo Accept: bg-amber-50 text-amber-500\n   8) Settings: bg-slate-100 text-slate-700\n*/\n.icon-pause-online-order {\n  background-color: #eff6ff; /* bg-blue-50 */\n  color: #3b82f6; /* text-blue-500 */\n}\n\n.icon-menu-stock {\n  background-color: #f5f3ff; /* bg-violet-50 */\n  color: #8b5cf6; /* text-violet-500 */\n}\n\n.icon-inventory-stock {\n  background-color: #f8fafc; /* bg-slate-50 */\n  color: #64748b; /* text-slate-500 */\n}\n\n.icon-completed {\n  background-color: #ecfdf5; /* bg-emerald-50 */\n  color: #10b981; /* text-emerald-500 */\n}\n\n.icon-font-change {\n  background-color: #e0e7ff; /* bg-indigo-50 */\n  color: #6366f1; /* text-indigo-500 */\n}\n\n.icon-recalled-list {\n  background-color: #fff1f2; /* bg-rose-50 */\n  color: #f43f5e; /* text-rose-500 */\n}\n\n.icon-redo-accept {\n  background-color: #fffbeb; /* bg-amber-50 */\n  color: #f59e0b; /* text-amber-500 */\n}\n\n.icon-settings {\n  background-color: #f1f5f9; /* bg-slate-100 */\n  color: #334155; /* text-slate-700 */\n}\n\n/* SVG icon size: h-4.5 w-4.5 -> 18px */\n.sidebar-icon-svg {\n  width: 1.286em; /* 18px at 14px base - relative for font scaling */\n  height: 1.286em; /* 18px at 14px base */\n}\n\n/* Text wrapper: text-center leading-tight */\n.sidebar-label-wrapper {\n  text-align: center;\n  line-height: 1.25; /* leading-tight */\n}\n\n/* Label: block text-[9px] font-medium leading-tight text-slate-600 */\n.sidebar-label {\n  display: block;\n  font-size: 0.643em; /* 9px at 14px base - relative for font scaling */\n  font-weight: 500;\n  line-height: 1.25;\n  color: #475569; /* text-slate-600 */\n}\n\n/* ==============================\n   Font Change Dropdown (No Layout Impact)\n   ============================== */\n.font-options-dropdown {\n  position: fixed; /* independent of sidebar layout */\n  top: 50%;\n  right: 105px; /* adjusted to sit perfectly next to the 90px sidebar */\n  transform: translateY(-50%);\n  background: #ffffff;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  border-radius: 12px;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);\n  z-index: 2000;\n  display: flex;\n  flex-direction: column;\n  padding: 6px;\n  width: 120px;\n}\n\n.font-options-dropdown button {\n  background: none;\n  border: none;\n  text-align: left;\n  padding: 8px 12px;\n  font-size: 0.929em; /* 13px at 14px base - relative for font scaling */\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  color: #475569;\n}\n\n.font-options-dropdown button:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n.font-options-dropdown button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.font-options-dropdown button.is-selected {\n  background-color: #eef2ff; /* indigo-50, matches the Font Change icon */\n  color: #4f46e5; /* indigo-600 */\n  font-weight: 600;\n}\n\n.font-options-dropdown button svg {\n  width: 14px;\n  height: 14px;\n  flex: 0 0 auto;\n}\n\n/* Optional small arrow (does not affect layout) */\n.font-options-dropdown::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: -6px;\n  transform: translateY(-50%) rotate(45deg);\n  width: 10px;\n  height: 10px;\n  background: #fff;\n  border-right: 1px solid rgba(226, 232, 240, 0.8);\n  border-top: 1px solid rgba(226, 232, 240, 0.8);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
